	<input *ngIf="inMatFormField"
		class="in-mat-form-field"
		type="text"
		#timeStringInput
		[(ngModel)]="timeString"
		(input)="onInput($event)"
		(change)="onChange($event)"
		(click)="onClick($event)"
		(blur)="onInputBlur($event)"
		(focus)="onInputFocus($event)" matInput />
	<input *ngIf="!inMatFormField"
		type="text"
		#timeStringInput
		[(ngModel)]="timeString"
		(input)="onInput($event)"
		(change)="onChange($event)"
		(click)="onClick($event)"
		(blur)="onInputBlur($event)"
		(focus)="onInputFocus($event)" />
